import React, { FC, useState, useCallback, useEffect } from 'react';
import {
  Grid,
  Box,
  Typography,
  Stack,
  IconButton,
  Button
} from '@mui/material';
import { AddCircleOutlineOutlined } from '@mui/icons-material';

import Notification from 'components/notification';
import DraggableList from 'components/draggableList';
import Loader from 'components/loader';
// import AddInfoPage from 'components/modals/addInfoPage';

import infoPagesStore from 'store/infoPagesStore';
import { EnumPath } from 'types/types';
import { observer } from 'mobx-react-lite';
import globalState from 'store/globalState';
import { useNavigate, useParams } from 'react-router-dom';
import AddInfoPage from 'components/modals/addInfoPage';

const Pages: FC = () => {
  const { id } = useParams();
  const { infoPages, loading } = infoPagesStore;

  const navigate = useNavigate();

  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState<boolean>(false);
  const [notificationStatus, setNotificationStatus] = useState<
    'error' | 'success' | 'warning'
  >('error');
  const [notificationMsg, setNotificationMsg] = useState<string>('');

  const notifyUser = useCallback(
    (message: string, status: 'error' | 'success') => {
      setNotificationMsg(message);
      setNotificationStatus(status);
      setIsNotificationOpen(true);
    },
    [setNotificationMsg, setNotificationStatus, setIsNotificationOpen]
  );

  const reload = useCallback(() => {
    if (id) {
      const response = infoPagesStore.getInfoPagesBySectionId(parseInt(id, 10));

      response.then((val) => {
        if (!val.isOk) {
          notifyUser(val.msg, 'error');
        }
      });
    }
  }, [id]);

  useEffect(() => {
    reload();

    globalState.setNewPathname('Инфостраницы');
    globalState.setRefreshFunction(infoPagesStore.getAllInfoPages, {});
  }, [id]);

  const onItemClick = useCallback(
    (idNumber: number) => () => {
      navigate(`/info-pages/${idNumber}`);
    },
    [navigate]
  );

  const onInfoPageAdd = (name: string, description: string, slug: string) => {
    const response = infoPagesStore.addInfoPage({
      name,
      description,
      section_id: parseInt(id || '0', 10),
      slug
    });

    response.then((val) => {
      notifyUser(val.msg, val.isOk ? 'success' : 'error');

      reload();
    });
  };

  return (
    <Grid
      sx={{
        width: '100%',
        height: '100%',
        overflowY: 'scroll'
      }}
      item
      xs={12}
      md={12}
    >
      <Notification
        open={isNotificationOpen}
        message={notificationMsg}
        onClose={() => {
          setIsNotificationOpen(false);
          setNotificationMsg('');
        }}
        severity={notificationStatus}
      />
      <AddInfoPage
        isOpen={modalIsOpen}
        setIsOpen={setModalIsOpen}
        onProductAdd={onInfoPageAdd}
      />
      {!loading ? (
        <Box sx={{ position: 'relative' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundColor: 'primary',
              width: 'auto',
              height: '48px'
            }}
          >
            <Typography variant="h6" sx={{ pl: 2 }}>
              Название
            </Typography>

            <Stack flexDirection="row">
              <IconButton onClick={() => setModalIsOpen(true)}>
                <AddCircleOutlineOutlined color="primary" />
              </IconButton>
              <Button variant="text" onClick={() => setModalIsOpen(true)}>
                Создать
              </Button>
            </Stack>
          </Box>
          <DraggableList
            list={infoPages}
            sectionId={parseInt(id || '0', 10)}
            pagesQuantity={1}
            notifyUser={notifyUser}
            onClick={onItemClick}
            onReload={reload}
            path={EnumPath.infopages}
          />
        </Box>
      ) : (
        <Loader />
      )}
    </Grid>
  );
};

export default observer(Pages);
